import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';

import Login from './Admin/Login';
import ForgotPassword from './Admin/ForgotPasswordPage';
import ResetPassword from './Admin/ResetPasswordPage';
import Quotes from './Admin/Quotes';
import Main_Page from './Admin/BBMainPage';
import ProductCategories from './ProductCategories/ProductCategories';
import NewProductCategory from './ProductCategories/NewProductCategory';
import EditProductCategory from './ProductCategories/EditProductCategory';

/* import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword'; */
import AllCustomers from './Customers/AllCustomers'
import ViewCustomer from './Customers/ViewCustomer';
import Home from './Admin/Home';
import NewCustomer from './Customers/NewCustomer';
import NewVendor from './Vendors/NewVendor'; 
import Allvendors from './Vendors/AllVendors';
import ProductAttributes from './ProductCategories/ProductAttributes';
import ProductVariants from './ProductCategories/ProductVariants';

import ViewProductCategory from './ProductCategories/ViewProductCategory'
import ViewVendor from './Vendors/ViewVendor';
 import ItemGroupsList from './ItemGroups/ItemGroupsList'
 import NewItemGroups from './ItemGroups/newItemGroup'
 import NewItem from './Items/NewItem'
 import ItemGroupDetails from './ItemGroups/ItemGroupDetails'
import EditVendor from './Vendors/EditVendor';
import BulkUploadItems from './Items/BulkUploadItems';
import ItemsList from './Items/ItemsList'
import ItemDetails from './Items/ItemDetails'
import NewPriceList from './Items/PriceList';
import EditCustomer from './Customers/EditCustomer';
import ViewPriceLists from './Items/ViewPriceLists';
import EditPriceList from './Items/EditPriceList';
import EditProductGroups from './ItemGroups/EditItemGroup';
import NewQuote from './Quotations/NewQuote';

import NewSalesOrder from './SalesOrder/NewSalesOrder';
import QuotationsList from './Quotations/QuotationsList';
import SalesOrdersItemWise from './SalesOrder/SalesOrdersItemWise';
import QuoteDetails from './Quotations/QuoteDetails';
import NewPurchaseOrder from './PurchaseOrder/NewPurchaseOrder';
import SalesOrderDetails from './SalesOrder/SalesOrderDetails';
import PurchaseOrdersItemWIse from './PurchaseOrder/PurchaseOrderItemWise';
import PurchaseOrdersList from './PurchaseOrder/PurchaseOrderList';
import EditSalesOrder from './SalesOrder/EditSalesOrder';
import EditQuote from './Quotations/EditQuote';
import PurchaseOrderDetails from './PurchaseOrder/PurchaseOrderDetails';
import SalesOrdersList from './SalesOrder/SaleOrdersList';
import EditPurchaseOrder from './PurchaseOrder/EditPurchaseOrder'

import Projects from '../Measurit_v3.0/ProjectList';
import NewProject from '../Measurit_v3.0/NewProject';
import ProjectDetails from '../Measurit_v3.0/ProjectDetails';
import BlockDetails from '../Measurit_v3.0/BlockDetails';
import NewMeasurements from '../Measurit_v3.0/Measurements/NewMeasurements';

import NewDeliveryChallans from './DeliveryChallans/NewDeliveryChallans';
import DeliveryChallansList from './DeliveryChallans/DeliveryChallansList';
import DeliveryChallanDetails from './DeliveryChallans/DeliveryChallanDetails';
import EditDeliveryChallan from './DeliveryChallans/EditDeliveryChallan';

import VehicalSchedulingDetails from './SalesOrder/VehicalSchedulingDetails';
import VehicalSheduling from './SalesOrder/VehicalSheduling';
import VehicleSheduleList from './SalesOrder/VehicleSheduleList';
import EditItems from './Items/EditItems';




import NewHub from './Settings/NewHub';
import HubList from './Settings/HubList';
import HubDetails from './Settings/HubDetails';
import EditHub from './Settings/EditHub';

import UserManagement from './Users/UserManagement';

import EditProject from '../Measurit_v3.0/EditProject';
import MaterialReq2 from '../ConsumerApp/MaterialReq2';
import PaymentReceivedList from './PaymentsReceived/PaymentReceivedList';
import NewPaymentReceived from './PaymentsReceived/NewPaymentReceived';
import PaymentReceivedDetails from './PaymentsReceived/PaymentReceivedDetails';
import InvoiceList from './Invoices/InvoicesList';
import NewInvoice from './Invoices/NewInvoice';
import InvoiceDetails from './Invoices/InvoiceDetails';
import EditInvoice from './Invoices/EditInvoice';
import EditPaymentReceived from './PaymentsReceived/EditPaymentReceived';

import NewRefund from './Refunds/NewRefund';
import EditRefund from './Refunds/EditRefund';
import RefundsList from './Refunds/RefundsList';
import RefundDetails from './Refunds/RefundDetails';
import RefundPdfViewer from './Refunds/RefundPdfViewer';

import NewTax  from './Settings/NewTax';
import TaxList from './Settings/TaxList';
import EditTax from './Settings/EditTax';
import TaxDetails from './Settings/TaxDetails';
import Template from './Templates/Template';
import HubProductAssignmentDashboard from './HubItems/HubProductAssignmentDashboard';

import PackageTemplate from './PakageTemplates/door_packages_template'
import TemplateList from './Templates/TemplateList';
import EditTemplate from './Templates/EditTemplate';

import RewardRulesList from './Buildcoins/rulesEngine/rulesList'
import RewardRulesSimulator from './Buildcoins/rulesEngine/rulesSimulator';

import RuleBuilder from './Rewards/NewRewardRule';
import RulesList from './Rewards/RewardRulesList';
import EditRule from './Rewards/EditRewardRule';
import RuleEngineFlow from './Buildcoins/cards';

import SupplierProductDashboard from './Quickbuy/SupplierProductDashboard';
import LiveOrdersDashboardPage from './Admin/liveOrdersDashboard/LiveOrdersDashboardPage';
import WalletManagement from './Buildcoins/WalletManagement';
import UsageAnalytics from './Buildcoins/UsageAnalytics';
import TransactionHistory from './Buildcoins/TransactionHistory';
import BuildCoinsSettings from './Buildcoins/BuildCoinsSettings';
import BuildCoinsDashboard from './Buildcoins/BuildCoinsDashboard';
import BudgetDashboard from './Buildcoins/BudgetDashboard';
import BudgetManagement from './Buildcoins/BudgetManagement';
import Simulator from './Admin/customerBuildcoinsSimulator';
//import RequestForQuotes from './RFQ/RequestForQuotes';
import RFQsTable from './RFQs/RFQs'
import MaterialRequirements from './MaterialRequirements/materialRequirements'
import OrdersTable from './Orders/orders';

import AdminAwardDecisionDemo from './AdminAwardDecisionDemo';
import AdminAwardDecision from './RFQAwarding/AdminAwardDecision';

import NewBill from './Bills/NewBill';
import BillList from './Bills/BillList';
import BillDetails from './Bills/BillDetails';
import EditBill from './Bills/EditBill';

import NewVendorPayment from './VendorPayments/NewVendorPayment';
import VendorPaymentList from './VendorPayments/VendorPaymentList';
import VendorPaymentDetails from './VendorPayments/VendorPaymentDetails';
import EditVendorPayment from './VendorPayments/EditVendorPayment';
import QuickBuyOrderManagement from './QuickbuyOrderManagement/QuickBuyOrderManagement';
import RFQFullfillmentFlow from './QuickbuyOrderManagement/components/RFQFulfillmentFlow'
import OrderFullfillmentFlow from './QuickbuyOrderManagement/components/OrderFulfillmentFlow'
import DeliveryFulfillmentFlow from './QuickbuyOrderManagement/components/DeliveryFulfillmentFlow';
import RewardLedgerList from './Rewards/RewardLedgerList';
//import RewardRulesSimulator from './Buildcoins/rulesEngine/rulesSimulator';
//import RewardRules from './Buildcoins/RewardRules';
//import ProjectBrickbucketSimulator from './Admin/projectBuildcoinsSimulator';
import { decryptData } from '../utils/storageCrypto';
import ProductPrice from './Reports/ProductPrice';
import DiscountRulesList from './Discounts/DiscountRulesList';
import DiscountRulesEngine from './Discounts/DiscountRulesEngine';
import Zones from './Settings/Zones'
import TicketsList from './Tickets/TicketsList';

//import DeliveryManagementDashboard from './QuickbuyOrderManagement/components/DeliveryManagementDashboard';

function App() {
  const [appId, setappId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  


  useEffect(() => {
    const checkAuthentication = () => {
      // Only check for protected routes
      if (location.pathname.startsWith('/admin/app')) {
        const encryptedToken = sessionStorage.getItem('token');
        const token = decryptData(encryptedToken);

        
        if (!token) {
          // No token, redirect to login
          clearAuthData();
          navigate('/admin');
          setLoading(false);
          return;
        }
        
        // Token exists, allow access
        setLoading(false);
      } else {
        setLoading(false);
      }
    };
    
    const clearAuthData = () => {
      localStorage.removeItem('LoginData');
      sessionStorage.removeItem('userData');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('userId');
      sessionStorage.removeItem('appId');
      sessionStorage.removeItem('hubId');
      sessionStorage.removeItem('roleId');
      sessionStorage.removeItem('roleName');
      sessionStorage.removeItem('hubName');
      sessionStorage.removeItem('hubNumber');
      sessionStorage.removeItem('hubCity');
    };
    
    checkAuthentication();
  }, [navigate, location.pathname]);


  // useEffect(() => {
  //   const BrickBucket = () => {
  //     if (location.pathname.startsWith('/admin')) {
  //       const storedLoginData = JSON.parse(localStorage.getItem('LoginData'));
  //       if (storedLoginData) {
  //         const appId = storedLoginData.appId;
  //       setappId(appId);
  //       setLoading(false);
  //       } else {
       
  //         if (location.pathname.startsWith('/admin') && 
  //         !location.pathname.startsWith('/admin/reset-password') &&
  //         !location.pathname.startsWith('/admin/forgot-password') &&
  //         !location.pathname.startsWith('/admin/reset-password')
  //     ) {
  //         navigate('/admin');
  //         setLoading(false);
  //     }
          
  //       }
  //     }
  //   };

  //   BrickBucket(); 
  // }, [navigate, location.pathname]); 

  if (loading) {
    return <div>Loading...</div>;
  }

  const AccessDenied = () => {
    return (
      <div
        className="fixed inset-0 bg-gray-500/50 flex justify-center items-center"
        style={{ backdropFilter: 'blur(100px)' }}
        role="dialog"
        aria-modal="true"
      >
<div className="bg-white rounded shadow-md p-8 max-w-md">
  <h2 className="text-lg font-bold text-center">Access Denied</h2>
  <p className="text-gray-600 text-center">You do not have permission to access this page.</p>
  <div className="flex justify-center mt-2">
    <button
      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-1 rounded"
      onClick={() => {
        sessionStorage.clear();
        localStorage.clear();
        navigate('/admin');
      }}
    >
      Go Back
    </button>
  </div>
</div>
      </div>
    );
  };

  return (
    <Routes>
      <Route path="/admin" element={<Login />} />
      {/*<Route path="/admin/d" element={<DeliveryManagementDashboard/>} />*/}
      {/*<Route path= "/admin/awarddecisiondemo" element= {<AdminAwardDecisionDemo/>}/>*/}
     
      {/* <Route path="/admin/rules" element={<RewardRules/>}/> */}
      <Route path="/admin/forgot-password" element={<ForgotPassword />} />
      <Route path="/admin/reset-password/:resetToken" element={<ResetPassword />} />
      <Route path="/admin/wm" element={<WalletManagement />} />
      <Route path="/admin/u" element={<UsageAnalytics />} />
      <Route path="/admin/th" element={<TransactionHistory />} />
      <Route path="/admin/bs" element={<BuildCoinsSettings />} />
      <Route path="/admin/bd" element={<BuildCoinsDashboard />} />
      <Route path="/admin/budget" element={<BudgetDashboard />} />
      <Route path="/admin/bm" element={<BudgetManagement />} />
      <Route path="/admin/s" element={<Simulator/>} />
      {/* <Route path="/admin/zones" element={<Zones />} /> */}
      {/* <Route path="/admin/ss" element={<ProjectBrickbucketSimulator/>} />*/}
      {/* <Route path="*" element={<AccessDenied />} />  */}
      <Route path="/admin/Quotes" element={<Quotes/>}/>
      <Route path='/admin/rules' element={<RuleEngineFlow/>} />
      <Route path="/admin/app" element={<Main_Page />}>
        <Route path="/admin/app/materialreq2" element={<MaterialReq2/>} />
        {/* <Route path='home' element = {<Home/>}/> */}
        <Route path='home' element = {<QuickBuyOrderManagement/>}/>
        <Route path="/admin/app/rfqfullfillmentflow" element={<RFQFullfillmentFlow/>} />
        <Route path="/admin/app/orderfullfillmentflow"element = {<OrderFullfillmentFlow/>}/>
        <Route path="/admin/app/deliveryfullfillmentflow" element = {<DeliveryFulfillmentFlow/>}/>
        <Route path="items/productCategories" element={<ProductCategories/>} />
        <Route path="items/editproductCategory" element={<EditProductCategory/>} />
        <Route path="items/newproductCategory" element={<NewProductCategory/>} />
        <Route path='items/productcategorydetails' element={<ViewProductCategory/>}/>
        <Route path='items/productgroupslist' element={<ItemGroupsList/>}/>
        <Route path='items/newproductgroups' element={<NewItemGroups/>}/>
        <Route path='items/productgroupdetails' element={<ItemGroupDetails/>}/>
        <Route path='items/productAttributes' element={<ProductAttributes/>} />
        <Route path='items/productvariants' element={<ProductVariants/>} />
        <Route path='items/newitem' element={<NewItem/>}/>
        <Route path='items/itemslist' element={<ItemsList/>}/>
        <Route path='items/itemdetails' element={<ItemDetails/>}/>
        <Route path='items/viewpricelists' element={<ViewPriceLists/>}/>
        <Route path='items/editpricelist' element={<EditPriceList/>} />
        <Route path='items/edititemgroup' element={<EditProductGroups/>}/>
        <Route path='items/edititems' element={<EditItems/>}/>
        <Route path='items/bulkuploaditems'element={<BulkUploadItems/>}/>
        <Route path='items/newpricelist' element={<NewPriceList/>} />
        <Route path='sales/customerslist' element = {<AllCustomers/>}/>
        <Route path='sales/customerdetails' element = { <ViewCustomer/>}/>
        <Route path='sales/newcustomer' element={<NewCustomer/>}/>
        <Route path='purchases/newvendor' element={<NewVendor/>} /> 
        <Route path='purchases/vendorslist' element={<Allvendors/>}/>
        <Route path='purchases/vendordetails' element={<ViewVendor/>} />    
        <Route path='purchases/editvendor' element={<EditVendor/>}/>
        <Route path='sales/editcustomer' element={<EditCustomer/>} />      
        <Route path='sales/newquote' element={<NewQuote/>}/>
        <Route path='sales/newsalesorder' element={<NewSalesOrder/>}/>
        <Route path='sales/quotelists' element={<QuotationsList/>} />
        <Route path='sales/salesordersitemwise' element={<SalesOrdersItemWise/>}/>
        <Route path='sales/salesorderslist' element={<SalesOrdersList/>}/>
        <Route path='sales/quotedetails' element={<QuoteDetails/>} />
        <Route path='purchases/newpurchaseorder' element={<NewPurchaseOrder/>}/>
        <Route path='sales/salesorderdetails' element={<SalesOrderDetails />} />
        <Route path='purchases/purchaseorderlist' element={<PurchaseOrdersList />} />
        <Route path='purchases/purchaseorderitemwise' element={<PurchaseOrdersItemWIse />} />
        <Route path='sales/editsalesorder' element={<EditSalesOrder />} />
        <Route path='sales/editquote' element={<EditQuote/>} />
        <Route path='sales/paymentreceivedlist' element={<PaymentReceivedList/>} />
        <Route path='sales/newpaymentreceived' element={<NewPaymentReceived/>} />
        <Route path='sales/paymentreceiveddetails' element={<PaymentReceivedDetails/>} />
        <Route path='sales/invoiceslist' element = {<InvoiceList/>} />
        <Route path='sales/newinvoice' element = {<NewInvoice/>} />
        <Route path='sales/invoicedetails' element = {<InvoiceDetails/>} />
        <Route path='sales/editinvoice' element = {<EditInvoice/>} />
        <Route path='sales/editpaymentreceived' element = {<EditPaymentReceived/>} />
        <Route path='sales/refundlist' element={<RefundsList/>} />
        <Route path='sales/newrefund' element={<NewRefund/>} />
        <Route path='sales/refunddetails' element={<RefundDetails/>} />
        <Route path='sales/editrefund' element={<EditRefund/>} />
        <Route path='sales/refundpdfviewer' element={<RefundPdfViewer/>} />
        <Route path='purchases/purchaseorderdetails' element={<PurchaseOrderDetails/>} />
        <Route path='purchases/editpurchaseorder' element={<EditPurchaseOrder/>} />    
        <Route path='projects/projectslist' element={<Projects/>} />  
        <Route path='projects/newproject' element={<NewProject/>} />
        <Route path='projects/projectdetails' element={<ProjectDetails/>} />
        <Route path='projects/blockdetails' element = {<BlockDetails/>}/>
        <Route path='projects/measurements' element={<NewMeasurements/>} />
        <Route path='projects/editproject' element={<EditProject/>} />
        <Route path='settings/zones' element={<Zones />} />
        <Route path='settings/newhub' element={<NewHub />} />
        <Route path='settings/hublist' element={<HubList/>} />
        <Route path='settings/hubdetails' element={<HubDetails/>} />
        <Route path='settings/edithub' element={<EditHub/>} />
        <Route path='settings/hub-products' element={<HubProductAssignmentDashboard />} />
        <Route path='settings/newtax' element={<NewTax />} />
        <Route path='settings/taxlist' element={<TaxList/>} />
        <Route path='settings/taxdetails' element={<TaxDetails/>} />
        <Route path='settings/edittax' element={<EditTax/>} />
        <Route path="settings/PackageTemplate" element = {<PackageTemplate/>}/>
        <Route path="settings/usermanagement" element = {<UserManagement/>}/>

        <Route path='deliverychallans/newdeliverychallans' element={<NewDeliveryChallans/>} />
        <Route path='deliverychallans/deliverychallanslist' element={<DeliveryChallansList/>} />
        <Route path='deliverychallans/deliverychallandetails' element={<DeliveryChallanDetails/>} />
        <Route path='deliverychallans/editdeliverychallan' element={<EditDeliveryChallan/>} />
        <Route path='sales/vehicleschedulingdetails' element={<VehicalSchedulingDetails/>} />
        <Route path='sales/newvehicleschedule' element={<VehicalSheduling/>} />
        <Route path='sales/vehicleshedulelist' element={<VehicleSheduleList/>} />
        <Route path='templates/template' element = {<Template/>} />
        <Route path='templates/templatelist' element = {<TemplateList/>} />
        <Route path='templates/edittemplate' element = {<EditTemplate/>} />
        <Route path='rewardrules/newrewardrule' element = {<RuleBuilder/>} />
        <Route path='rewardrules/rewardruleslist' element = {<RewardRulesList/>} />
        <Route path='rewardrules/editrewardrule' element = {<EditRule/>} />
        <Route path='rewardrules/rewardrulesimulator' element = {<RewardRulesSimulator/>} />
        <Route path='discountrules/discountruleslist' element = {<DiscountRulesList/>} />
        <Route path='discountrules/discountrulesengine' element = {<DiscountRulesEngine/>} />
        <Route path='purchases/SupplierProducts' element = {<SupplierProductDashboard/>} />
        <Route path="sales/liveorders" element={<LiveOrdersDashboardPage />} />
        {/* <Route path="rfq/rfqrequirements" element={<RequestForQuotes />} /> */}
         <Route path="rfq/rfqrequirements" element={<RFQsTable />} />
         <Route path= "sales/orders" element = {<OrdersTable/>}/>
         <Route path="sales/rfq/adminaward" element={<AdminAwardDecision />} />
       
       <Route path='mr/materialrequirements' element = {<MaterialRequirements/>}/>

       <Route path='bills/newbill' element = {<NewBill/>}/>
       <Route path='bills/billlist' element = {<BillList/>}/>
       <Route path='bills/billdetails' element = {<BillDetails/>}/>
       <Route path='bills/editbill' element = {<EditBill/>}/>

       <Route path='vendorpayments/newvendorpayment' element = {<NewVendorPayment/>} />
       <Route path='vendorpayments/vendorpaymentlist' element = {<VendorPaymentList/>}/>
       <Route path='vendorpayments/vendorpaymentdetails' element = {<VendorPaymentDetails/>}/>
       <Route path='vendorpayments/editvendorpayment' element = {<EditVendorPayment/>}/>

       <Route path='rewards/rewardledgerlist' element = {<RewardLedgerList/>} />
       <Route path='reports/productpricereports' element = {<ProductPrice/>} />

       <Route path="tickets/ticketslist" element={<TicketsList />} />

      
      </Route>
    </Routes>
  );
}

export default App;
